import React from 'react';
import { View, Dimensions } from 'react-native';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from "redux";
import PropTypes from 'prop-types';

import Colors from "../constants/Colors";
import Drawer from './drawer/Drawer';
import { Header } from "./header/Header";

import { handleDrawerClick } from "../redux/actions";
import {ButtonImage} from "./button/ButtonImage";

class NavBar extends React.Component {

    state = {
        dimensions: null,
    }

    handleResize = (dimensions) => {
        this.setState({ dimensions: dimensions });
    }

    componentDidMount() {
        Dimensions.addEventListener("change", this.handleResize)
    }

    componentWillUnmount() {
        Dimensions.removeEventListener("change", this.handleResize);
    }

    render() {

        const { width, height } = Dimensions.get('window')

        return(
            <View style={{
                flex: 1,
                backgroundColor: Colors.backgroundColor,
                flexDirection: 'row',
                minHeight: this.state.dimensions === null ? height : this.state.dimensions.window.height,

            }}>

                {
                    this.props.showDrawer === true &&
                        <Drawer />
                }

                <View style={{ backgroundColor: Colors.backgroundColor, flex: 5, }}>

                    <View style={{
                        flexDirection: 'row',
                        alignSelf: 'stretch',
                        backgroundColor: Colors.navBarColor,
                        padding: 8,
                        paddingLeft: 32,
                        alignItems: 'center'
                    }}>

                        <ButtonImage
                            onPress={() => this.props.handleDrawerClick()}
                            imageSource={require('../img/icons/hamburger-menu.png')}
                            imagePropsStyle={{ height: 32, width: 32, tintColor: Colors.navBarIconColor }}
                        />

                        <Header
                            headerText={this.props.title}
                            containerPropsStyle={{
                                alignSelf: 'stretch',
                                height: 50,
                                justifyContent: 'center',
                            }}
                            textPropsStyle={{ color: Colors.navBarTitleColor }}
                        />
                    </View>

                    <View style={{ flex: 1, alignItems: 'center' }}>
                        <View style={{ flex: 1, maxWidth: 800, padding: 22 }}>
                            {this.props.children}
                        </View>
                    </View>


                </View>
            </View>
        )
    }
}

NavBar.propTypes = {
    title: PropTypes.string,
    showBackButton: PropTypes.bool
};

const mapStateToProps = state => {
    return {
        showDrawer: state.drawer.showDrawer,
    }
}

export default compose(
    withRouter,
    connect(mapStateToProps, { handleDrawerClick })
)(NavBar);
